import React from 'react';
import { IncidentDialog } from '../../components/law/IncidentDialog';
import { IncidentList } from '../../components/law/IncidentList';
import { IncidentStats } from '../../components/law/IncidentStats';
import { SectionHeader } from '../../components/ui/SectionHeader';
import { useEscapeKey } from '../../hooks/useEscapeKey';
import { demoIncidents, Incident, IncidentStatus } from './incidentsData';

type IncidentsProps = {
  activeOnly?: boolean;
};

export function Incidents({ activeOnly = true }: IncidentsProps) {
  const [incidents, setIncidents] = React.useState<Incident[]>(() => demoIncidents);
  const [selectedIncident, setSelectedIncident] = React.useState<Incident | null>(null);

  const closeIncident = React.useCallback(() => setSelectedIncident(null), []);
  useEscapeKey(Boolean(selectedIncident), closeIncident);

  const visibleIncidents = activeOnly
    ? incidents.filter((incident) => incident.status !== 'resolved')
    : incidents;

  const updateIncidentStatus = (id: string, status: IncidentStatus) => {
    setIncidents((current) => current.map((incident) => (
      incident.id === id ? { ...incident, status } : incident
    )));
    setSelectedIncident(null);
  };

  return (
    <div className="law-dashboard">
      {activeOnly ? <IncidentStats incidents={incidents} /> : null}

      <section>
        <SectionHeader
          actions={<button className="btn btn-sm" type="button">Filter</button>}
          title={activeOnly ? 'Active incidents' : 'All incidents'}
        />
        <IncidentList incidents={visibleIncidents} onSelectIncident={setSelectedIncident} />
      </section>

      {selectedIncident ? (
        <IncidentDialog
          incident={selectedIncident}
          onClose={closeIncident}
          onUpdateStatus={updateIncidentStatus}
        />
      ) : null}
    </div>
  );
}
